<template>
<div>
	<div
		role="button"
		class="aup-public-profile__report-button"
		@click="openReportModal()"
	>
		<IconReport />
		<div class="aup-public-profile__tooltip--container d-inline-block" v-if="!isSelfProfile">
			<p class="aup-public-profile__tooltip t-micro t-micro--regular p-1">Report Profile</p>
		</div>
	</div>
    <BaseModal size="md" v-model="showReportModal" :noPadding="true">
        <template v-slot:header>
            <div class="d-flex justify-content-between px-5 py-3">
                <h3 v-if="reportTypePhoto" class="t-heavy mb-0">Report error:call:39's Photograph</h3>
                <h3 v-else class="t-heavy mb-0">Report error:call:40's Profile</h3>
                <BaseButton
                    :filled="true"
                    border="round"
                    color="black"
                    @click="closeReportModal"
                >
                    <IconClose />
                </BaseButton>
            </div>
            <hr class="m-0" />
        </template>
        <template v-slot:body v-if="!reportProfileSubmitted">
            <BaseLineBox label="Reason for reporting" class="m-4">
                <BaseBoxSelect
                    :items="reportReasonsMockData"
                    v-model="reportReason"
                    class="p-4 flex-column align-content-center"
                />
            </BaseLineBox>
            <p class="aup-input-error t-micro text-danger mt-1 mb-0 px-4" v-if="reportReasonError">error:call:41</p>
            <BaseTextArea
                class="m-4 d-flex flex-column"
                v-model="reportMessage"
                :label="messageLabel"
                :maxLength="500"
                :error="reportMessageError"
            />
            <div class="d-flex m-4">
                <BaseButton
                    class="mt-2"
                    @click="handleReportSubmit"
                >Report</BaseButton>
                <BaseButton
                    class="mt-2 ml-2"
                    @click="closeReportModal"
                    :filled="false"
                    color="black"
                    border="thin"
                >Cancel</BaseButton>
            </div>
        </template>
        <template v-slot:body v-else>
            <div class="d-flex flex-column p-5 h-100">
                <div class="d-flex flex-column justify-content-center" style="flex-grow: 1;">
                    <h3>Your report has been sent.</h3>
                    <h5
                        class="t-regular"
                    >Our content moderation team will review and take appropriate action.</h5>
                </div>
                <div>
                    <BaseButton class @click="closeReportModal">Close</BaseButton>
                </div>
            </div>
        </template>
    </BaseModal>

</div>
</template>

<script>

export default {
    name: 'BaseReport',
    props: {
		reportTypePhoto: {
            type: Boolean,
            default: true,
        },
        reportReasonsMockData: {
            type: Array,
            default: [],
        },
        userName: {
            type: String,
            default: '',
		},
		reportItemGuid: {
			type: String,
			required: true,
		},
        isSelfProfile: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            reportMessage: '',
            reportReason: [],
			reportReasonError: '',
			reportMessageError: '',
			reportProfileSubmitted: false,
			showReportModal: false,
        };
    },
    computed: {
        requiresMessage() {
            return this.reportReason.some(reason => reason.toLowerCase() === 'other');
        },
        messageLabel() {
            return this.requiresMessage ? 'Message to sony (required)' : 'Message to sony';
        },
		// getReportItemGuid: {
		// 	get() {
		// 		return reportTypePhoto : this.$store.state.Public.publicUser.profile.ppd_publicprofileid ? this.$store.state.Public.publicUser.profile.ppd_publicprofileid
		// 	},
		// }
	},
	watch: {
		showModal: function(){
			if(this.showReportModal == false){
				this.$emit('onClose');
			}
		},
		reportReason(val) {
			if (val.length) {
				this.reportReasonError = '';
			}
			if (!val.some(reason => reason.toLowerCase() === 'other')) {
				this.reportMessageError = '';
			}
		},
		reportMessage(val) {
			if (val.trim()) {
				this.reportMessageError = '';
			}
		},
	},
    mounted() {},
    methods: {
		closeReportModal() {
			this.showReportModal = false;
		},
		openReportModal() {
			this.showReportModal = true;
        },
		// closeModal() {
		// 	this.$emit('onClose')
		// },
		validateReportForm() {
			if (!this.reportReason.length) {
				this.reportReasonError = 'Please select at least one reason for reporting.';
				return false;
			}
			this.reportReasonError = '';

			if (this.requiresMessage && !this.reportMessage.trim()) {
				this.reportMessageError = 'Please enter a message when selecting Other as a reason.';
				return false;
			}
			this.reportMessageError = '';
			return true;
		},
		handleReportSubmit() {
			if (!this.validateReportForm()) {
				return;
			}
			if (this.reportTypePhoto) {
				this.submitMediaReport(this.reportItemGuid);
			} else {
				this.submitProfileReport(this.reportItemGuid);
			}
		},
		submitMediaReport(reportItemGuid) {
			this.$store.dispatch('reportProfileOrImage', {
				"ppd_usermediaid": reportItemGuid,
				"ppd_reason": this.reportReason.join(','),
				"ppd_message": this.reportMessage,
			});
			this.reportProfileSubmitted = true;
		},
		submitProfileReport(reportItemGuid) {
			this.$store.dispatch('reportProfileOrImage', {
				"ppd_publicprofileid": reportItemGuid,
				"ppd_reason": this.reportReason.join(','),
				"ppd_message": this.reportMessage,
			});
			this.reportProfileSubmitted = true;
		},
    },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/all.scss';

.aup-public-profile {

	&__report-button:hover {
        &
            .aup-public-profile__tooltip--container
            .aup-public-profile__tooltip {
            opacity: 1;
        }
	// dl : commenting out per design but leaving in case design changes mind
		// .icon__report-flag {
		// 	fill: $primary;
		// }
    }
    &__report-button {
        cursor: pointer;
		position: relative;
		top: 50%;
		transform: translateY(-50%);
    }
	&__tooltip {
        opacity: 0;
        transition: opacity 0.3s ease-in;
        bottom: 75px;
        // margin-left: -0.2rem;
        min-width: 100px;
        border-radius: 2px;
        background-color: $gray-300;
        color: $sony-black;
        text-align: center;
        &:before {
            content: '';
            position: absolute;
            border-style: solid;
            display: block;
            margin-top: 26px;
            margin-left: 76px;
            border-color: $gray-300 transparent;
            border-width: 5px 5px 0;
        }
        &--container {
            z-index: map-get($zindices, fixed);
            position: absolute;
            bottom: 25px;
			right: 1%;
			@include media-breakpoint-down(md) {
				top: -50px;
				right: 1.5%;
			}
        }
    }
}
</style>

